export const HOME = '/';
export const TRACK = 'track-package';
export const SHIP = 'ship';
export const BOOK_SHIPMENT = 'book-shipment';
export const ABOUT_US = 'about-us';
export const CONTACT = 'contact';
export const ENTERPRISE_LOGISTICS = 'enterprise-logistic';
export const SUPPLY_CHAIN_STORAGE = 'supply-chain-storage';
export const CUSTOM_CLEARANCE = 'custom-clearance';
export const BOUNDED_TERMINALS = 'bonded-terminals';
export const LAST_MILE_DELIVERY = 'last-mile-delivery';
export const BECOME_A_PARTNER = 'become-a-partner';
export const IMPORT_FROM_CHINA = 'import-from-china';
export const GLOBAL_IMPORTS = 'global-imports';
export const JOIN_WAITLIST = 'join-waitlist';

export const PAYMENT_SUCCESS = 'payment-successful';

export const NOT_FOUND = '404';
